import React, { useState, memo, Fragment, useEffect, useMemo } from "react";
import { useTable, useExpanded } from "react-table";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { isArray, result } from "lodash";
import classNames from "classnames";
import { format, differenceInDays, getDaysInYear } from "date-fns";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import numeral from "numeral";
import Skeleton from "react-loading-skeleton";
import PaymentModal from "./footage/leasing.f.paymentmodal";
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../utils/getLocalDateTime";
import { getDifferenceInDays } from "Leasing/util";
import { getInstallmentDueDate } from "Leasing/util";
import { getInstallmentBillDate } from "Leasing/util";
import { calculatePayPerMonth } from "Leasing/util";
import { daysInYear } from "Leasing/util";
import { Auth, Storage } from "aws-amplify";
import CelesFloatingInputState from "./components/leasing.c.celesfloatinginputstate";
import { getAsk } from "Leasing/util";
import LoadingPage from "../../components/Loading/LoadingPage";
import moment from "moment";
import { calTotalLeasing } from "../../utils/cal";
import {
  ChevronDownIcon,
  ChevronDoubleRightIcon,
  ChevronRightIcon,
  PlusSmIcon,
  MinusSmIcon,
} from "@heroicons/react/outline";
import FootageLoanMetaData from "./footage/leasing.f.loanmetadata";
import FootageUserData from "./footage/leasing.f.userdata";
import FootageEvidences from "./footage/leasing.f.evidences";
import Line from "./components/leasing.c.line";
import FootageTableInfo from "./footage/leasing.f.tableinfo";
import { ReversePaymentProvider } from "./context/leasing.ctx.reversePayment";
import DrawerReversePayment from "./components/leasing.c.drawerReversePayment";
import { getFilterInstallments } from "components/Leasing/utils/leasing.u";
import { EVIDENCE_TABS } from "./constrant/leasing.ct.options";
import FootageEvidencesAddFee from "./footage/leasing.f.evidencesAddFee";
import FootageFeeData from "./footage/leasing.f.feedata";
import FootageOtherFeeData from "./footage/leasing.f.otherFeedata";
import { EmitterStatus } from "../../event";
import FootageEvidencesFee from "./footage/leasing.f.evidencesFee";
import FootageDetail from "./footage/leasing.f.detailTF";
import qs from "query-string";
import API from "./api/api.main";
import InterfaceCreateModal from "components/Leasing/footage/leasing.f.InterfaceCreateModal";
import AccruedInterestModal from "components/Leasing/footage/leasing.f.accruedInterestModal";
import ARClearModal from "components/Leasing/footage/leasing.f.arClearModal";
import PostOtherRevenueModal from "components/Leasing/footage/leasing.f.postOtherRevenueModal";
import ContractCancelModal from "./footage/leasing.f.contractCancelModal";
import SeizeVehicleModal from "./footage/leasing.f.seizeVehicleModal";
import TransferVehicleModal from "./footage/leasing.f.transferVehicleModal";
import BuroModal from "./footage/leasing.f.buroModal";

function LeasingLoanInfoMain() {
  const [oriLoan, setOriLoan] = useState();
  const [loan, setLoan] = useState();
  const [installments, setInstallments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingEvidence, setLoadingEvidence] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [evidences, setEvidences] = useState([]);
  const [tab, setTab] = useState(1);
  const [date, setDate] = useState(
    new Date(getCurrentLocalDateTime().fullDate)
  );
  const [isPlus, setIsPlus] = useState(true);
  const [headerTotal, setHeaderTotal] = useState(0);
  const [listIsPlus, setListIsPlus] = useState([]);
  const [interest, setInterest] = useState({});
  const [isChange, setIsChange] = useState(false);
  const [openModalBuro, setOpenModalBuro] = useState(false);
  const [buroData, setBuroData] = useState([]);
  const [searchBuro, setSearchBuro] = useState("");
  const [filePayment, setFilePayment] = useState(null);
  const [filePaymentBase, setFilePaymentBase] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);

  const [openModalInterface, setOpenModalInterfaceCreate] = useState(false);
  const [openModalARClear, setOpenModalARClear] = useState(false);
  const [openModalAccruedInterest, setOpenModalAccruedInterest] =
    useState(false);
  const [openModalPost, setOpenModalPost] = useState(false);
  const [openModalContractCancel, setOpenModalContractCancel] = useState(false);
  const [openModalSeizeVehicle, setOpenModalSeizeVehicle] = useState(false);
  const [openModalTransferVehicle, setOpenModalTransferVehicle] =
    useState(false);
  const [totalCancel, setTotalCancel] = useState(0);
  const params = useParams();

  useEffect(() => {
    setDate(getCurrentLocalDateTime(date).fullDate);
  }, [date]);

  useEffect(() => {
    getInterest();
  }, []);

  useEffect(() => {
    getLoadEvidence(tab);
  }, [params, tab, loadingUpdate]);

  useEffect(() => {
    const defaultDate =
      sessionStorage.getItem(`${params.loan_id}_date`) || date;
    getLoanId(true, defaultDate);
    setDate(defaultDate);
  }, [params, isChange]);

  const getLoadEvidence = async (tab) => {
    if (tab === 1) {
      await getEvidence();
    } else if (tab === 2) {
      await getEvidenceFee();
    } else if (tab === 3) {
      await getAddEvidenceFee();
    }
  };

  const getInterest = async () => {
    try {
      const dataReturnCar = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=RETURN_CAR`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const dataVisitFee = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=VISIT_FEE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const dataBreakFee = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=BREAK_FEE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const dataReturnCarDate = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=RETURN_CAR_DATE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const dataDemandFee = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=DEMAND_FEE_NTF_ONE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const dataInterestDatePenalty = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=INTEREST_PENALTY_DATE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setInterest({
        ...interest,
        RETURN_CAR_DATE: dataReturnCarDate.RETURN_CAR_DATE,
        RETURN_CAR: dataReturnCar.RETURN_CAR,
        VISIT_FEE: dataVisitFee.VISIT_FEE,
        BREAK_FEE: dataBreakFee.BREAK_FEE,
        DEMAND_FEE: dataDemandFee.DEMAND_FEE_NTF_ONE,
        INTEREST_PENALTY_DATE: dataInterestDatePenalty.INTEREST_PENALTY_DATE,
      });
    } catch (error) {}
  };

  const getEvidence = async () => {
    try {
      setLoadingEvidence(true);
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/loan/evidences/${params.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setEvidences(data?.evidences);
    } catch (error) {
      console.log("get evidence error", error);
    } finally {
      setLoadingEvidence(false);
    }
  };

  const getEvidenceFee = async () => {
    try {
      setLoadingEvidence(true);
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/loan/evidencesFee/${params.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setEvidences(data?.evidences_fees);
    } catch (error) {
      console.log("get evidence error", error);
    } finally {
      setLoadingEvidence(false);
    }
  };

  const getAddEvidenceFee = async () => {
    try {
      setLoadingEvidence(true);
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/loan/evidencesAddFee/${params.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setEvidences(data?.evidences_add_fees);
    } catch (error) {
      console.log("get evidence error", error);
    } finally {
      setLoadingEvidence(false);
    }
  };

  const getLoanId = async (firstLoading = true, date) => {
    try {
      setLoading(firstLoading);

      let defaultDate = date;

      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/loan/${params.loan_id}?installment_type=L&paid_date=${
          getCurrentLocalDateTime(new Date(defaultDate)).dateTime
        }`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setOriLoan(_.cloneDeep(data?.leasing));
      setLoan(_.cloneDeep(data?.leasing));
      const installments = getFilterInstallments(data?.leasing?.installments);
      setInstallments(installments);
      setListIsPlus(_.cloneDeep(installments));
      setHeaderTotal(0);
      setIsPlus(true);
      setLoading(false);
    } catch (error) {
      console.log("get load loan_id", error);
    } finally {
    }
  };

  const paid = async (amount, date, priceType) => {
    try {
      setLoadingUpdate(true);

      let filePaymentKey = "";
      if (filePayment) {
        const fileUploaded = await Storage.put(
          `${filePayment.name}`,
          filePayment
        );
        filePaymentKey = fileUploaded.key;
      }

      await API.post("MoneyHubAdmin", `/leasing/loanPayment/${loan.loan_id}`, {
        body: {
          paid_amount: amount,
          paid_date: getCurrentLocalDateTime(date).isoDateTime,
          bill_img: filePaymentKey,
          priceType,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      sessionStorage.setItem(
        `${params.loan_id}_date`,
        getCurrentLocalDateTime(date).fullDate
      );
      setIsChange(!isChange);
      if (loan?.total_fee > 0) {
        setTab(2);
      } else {
        setTab(1);
      }
      setIsSubmit(true);
      setOpenModal(false);
    } catch (error) {
      console.log("paid error", error);
      await EmitterStatus("ERROR", {
        text: error?.response?.data?.message || error?.message,
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  const actionServiceFee = async (amount, fee_remark, date) => {
    try {
      setLoadingUpdate(true);

      sessionStorage.setItem(
        `${params.loan_id}_date`,
        getCurrentLocalDateTime(date).fullDate
      );

      let filePaymentKey = "";
      if (filePayment) {
        const fileUploaded = await Storage.put(
          `${filePayment.name}`,
          filePayment
        );
        filePaymentKey = fileUploaded.key;
      }

      await API.put("MoneyHubAdmin", `/leasing/loan/fee/${loan.loan_id}`, {
        body: {
          paid_amount: amount,
          fee_remark: fee_remark,
          bill_img: filePaymentKey,
          paid_date: getCurrentLocalDateTime(date).isoDateTime,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      // await EmitterStatus("SUCCESS");
      setTab(2);
      setIsChange(!isChange);
      setOpenModal(false);
    } catch (error) {
      console.log("action service fee", error);
      await EmitterStatus("ERROR", {
        text: error?.response?.data?.message || error?.message,
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  const actionFee = async (amount, type, fee_remark, date) => {
    try {
      setLoadingUpdate(true);

      sessionStorage.setItem(
        `${params.loan_id}_date`,
        getCurrentLocalDateTime(date).fullDate
      );

      let filePaymentKey = "";
      if (filePayment) {
        const fileUploaded = await Storage.put(
          `${filePayment.name}`,
          filePayment
        );
        filePaymentKey = fileUploaded.key;
      }

      const data = await API.put(
        "MoneyHubAdmin",
        `/leasing/loan/addFee/${loan.loan_id}`,
        {
          body: {
            fee_remark,
            fee_amount: amount,
            fee_type: type,
            bill_img: filePaymentKey,
            paid_date: getCurrentLocalDateTime(date).isoDateTime,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      if (data.type === "E") {
        await EmitterStatus("ERROR", { text: data?.message });
        return;
      }
      // await EmitterStatus("SUCCESS");
      setIsChange(!isChange);
      setTab(3);
      setOpenModal(false);
    } catch (error) {
      console.log("add Fee", error);
      await EmitterStatus("ERROR", {
        text: error?.response?.data?.message || error?.message,
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  const onChangeDate = (e) => {
    setDate(e);
  };

  const onClickSubmit = async () => {
    let newDate = date;
    if (date === "NaN-NaN-NaN") {
      newDate = sessionStorage.getItem(`${params.loan_id}_date`);
    }

    getLoanId(true, newDate);
    getLoadEvidence(tab);
    setDate(newDate);
  };

  const onClickIsPlus = (is_true) => {
    setIsPlus(is_true);
    if (!is_true) {
      setHeaderTotal(0);
      setListIsPlus(
        installments.map((installment) => {
          return {
            _id: installment.id,
            isPlus: true,
          };
        })
      );
    }
  };

  const onClickTab = (tab) => async () => {
    setTab(tab.value);
    await getLoadEvidence(tab.value);
  };

  return (
    <ReversePaymentProvider>
      <DrawerReversePayment
        refetch={getLoanId}
        date={date}
        loan={loan}
        oriLoan={oriLoan}
        evidences={evidences}
        getEvidence={getEvidence}
        setDate={setDate}
      />

      <div className="fixed z-10 inset-0 h-full bg-gray-100 p-2 overflow-hidden overflow-y-auto ">
        <SeizeVehicleModal
          loan={loan}
          openModalSeizeVehicle={openModalSeizeVehicle}
          setOpenModalSeizeVehicle={setOpenModalSeizeVehicle}
          env="prod"
        />
        <TransferVehicleModal
          loan={loan}
          openModalTransferVehicle={openModalTransferVehicle}
          setOpenModalTransferVehicle={setOpenModalTransferVehicle}
          env="prod"
        />
        <ContractCancelModal
          loan={loan}
          openModalContractCancel={openModalContractCancel}
          setOpenModalContractCancel={setOpenModalContractCancel}
          env="prod"
        />
        <PostOtherRevenueModal
          loan={loan}
          openModalPost={openModalPost}
          setOpenModalPost={setOpenModalPost}
          env="prod"
        />
        <InterfaceCreateModal
          loan={loan}
          openModalInterface={openModalInterface}
          setOpenModalInterfaceCreate={setOpenModalInterfaceCreate}
          env="prod"
        />
        <AccruedInterestModal
          loan={loan}
          openModalAccruedInterest={openModalAccruedInterest}
          setOpenModalAccruedInterest={setOpenModalAccruedInterest}
          env="prod"
        />
        <ARClearModal
          loan={loan}
          openModalARClear={openModalARClear}
          setOpenModalARClear={setOpenModalARClear}
          env="prod"
        />
        <PaymentModal
          paidDate={date}
          loading={loadingUpdate}
          action={paid}
          totalCancel={totalCancel}
          actionFee={actionFee}
          actionServiceFee={actionServiceFee}
          open={openModal}
          setOpen={setOpenModal}
          loan={loan}
          interest={interest}
          setFilePayment={setFilePayment}
          filePayment={filePayment}
          setFilePaymentBase={setFilePaymentBase}
          filePaymentBase={filePaymentBase}
          isSubmit={isSubmit}
        />
        <BuroModal
          openModalBuro={openModalBuro}
          setOpenModalBuro={setOpenModalBuro}
          setBuroData={setBuroData}
          buroData={buroData}
          searchBuro={searchBuro}
          setSearchBuro={setSearchBuro}
        />
        <div className="h-screen gap-2">
          <FootageLoanMetaData
            env="prod"
            date={date}
            getLoanId={getLoanId}
            paidDate={date}
            loan={loan}
            setOpenModalPost={setOpenModalPost}
            setOpenModal={setOpenModal}
            setOpenModalBuro={setOpenModalBuro}
            setBuroData={setBuroData}
            openModalInterface={openModalInterface}
            setOpenModalInterfaceCreate={setOpenModalInterfaceCreate}
            openModalARClear={openModalARClear}
            setOpenModalARClear={setOpenModalARClear}
            openModalAccruedInterest={openModalAccruedInterest}
            setOpenModalAccruedInterest={setOpenModalAccruedInterest}
            setOpenModalContractCancel={setOpenModalContractCancel}
            setOpenModalSeizeVehicle={setOpenModalSeizeVehicle}
            setOpenModalTransferVehicle={setOpenModalTransferVehicle}
          />
          <Line />
          <FootageUserData
            date={date}
            loan={loan}
            onChangeDate={onChangeDate}
            onClickSubmit={onClickSubmit}
          />
          {loan?.category === "TF" && (
            <React.Fragment>
              {" "}
              <Line />
              <FootageDetail
                interest={interest}
                date={date}
                loan={loan}
                setOpenModal={setOpenModal}
              />
            </React.Fragment>
          )}
          {loan?.category === "TF" && (
            <React.Fragment>
              {" "}
              <Line />
              <FootageFeeData
                totalCancel={totalCancel}
                setTotalCancel={setTotalCancel}
                interest={interest}
                date={date}
                loan={loan}
                setOpenModal={setOpenModal}
              />
            </React.Fragment>
          )}

          <div className="py-2 px-2">
            <div className="flex space-x-2 mb-1">
              {EVIDENCE_TABS.map((EVIDENCE_TAB, index) => {
                return (
                  <button
                    onClick={onClickTab(EVIDENCE_TAB)}
                    key={index}
                    className={classNames(
                      "text-sm px-3 py-2 bg-white cursor-pointer hover:text-blue-600 transition-colors duration-300",
                      {
                        "text-blue-500": EVIDENCE_TAB.value === tab,
                        "text-gray-500": EVIDENCE_TAB.value !== tab,
                      }
                    )}
                  >
                    {EVIDENCE_TAB.label}
                  </button>
                );
              })}
            </div>

            {/* หลักฐานการชำระเงินปกติ */}
            {loadingEvidence || loadingUpdate ? (
              <div className="grid grid-cols-6 gap-4 pb-4 pt-2 ">
                <Skeleton count={1} height={80} />
                <Skeleton count={1} height={80} />
                <Skeleton count={1} height={80} />
                <Skeleton count={1} height={80} />
                <Skeleton count={1} height={80} />
                <Skeleton count={1} height={80} />
              </div>
            ) : (
              <div className="w-screen pr-4 flex flex-row space-x-2  pt-1 pb-2 overflow-x-scroll ">
                {evidences?.length > 0 &&
                  evidences.map((item, index) => {
                    if (tab === 1) {
                      return (
                        <FootageEvidences
                          key={index}
                          item={item}
                          loan={loan}
                          setLoan={setLoan}
                          index={index}
                          setInstallments={setInstallments}
                          setLoading={setLoading}
                          setDate={setDate}
                          refetch={getLoanId}
                          date={date}
                          env="production"
                        />
                      );
                    } else if (tab === 2) {
                      return (
                        <FootageEvidencesFee
                          key={index}
                          item={item}
                          loan={loan}
                          setLoan={setLoan}
                          index={index}
                          setInstallments={setInstallments}
                          setLoading={setLoading}
                          setDate={setDate}
                        />
                      );
                    } else if (tab === 3) {
                      return (
                        <FootageEvidencesAddFee
                          key={index}
                          item={item}
                          loan={loan}
                          setLoan={setLoan}
                          index={index}
                          setInstallments={setInstallments}
                          setLoading={setLoading}
                          setDate={setDate}
                        />
                      );
                    }
                    return null;
                  })}
              </div>
            )}
          </div>
          <div className="relative bg-white rounded flex-grow border-blue-400 overflow-scroll w-screen pb-16">
            <FootageTableInfo
              onClickIsPlus={onClickIsPlus}
              headerTotal={headerTotal}
              setHeaderTotal={setHeaderTotal}
              isPlus={isPlus}
              setIsPlus={setIsPlus}
              setListIsPlus={setListIsPlus}
              listIsPlus={listIsPlus}
              loading={loading || loadingUpdate}
              loan={loan}
              installments={installments}
              setInstallments={setInstallments}
            />
          </div>
        </div>
      </div>
    </ReversePaymentProvider>
  );
}

export default LeasingLoanInfoMain;
